























import { Component, Vue } from 'vue-property-decorator';
@Component({})
export default class Menu extends Vue {
  mounted() {
    this.get_menuList();
  }
  menuContent = [];
  apiList = [];
  menuRole: any[] = [];
  menuList = [];
  urlList = [];
  menuObj = {
    acct: '账号管理,el-icon-tickets',
    dpt: '部门管理,el-icon-user',
    cg: '分组管理,el-icon-reading',
    // "subscriber": "订阅者管理-mail",
    // "staff-subscriber": "订阅者管理-mail",
    sim: 'SIM卡管理,el-icon-message',
    define: '定义管理,el-icon-s-check',
    rule: '规则管理,el-icon-setting',
    sub: '订阅管理,el-icon-search',
    sms: 'SMS管理,el-icon-chat-dot-round',
    user_log: '用户日志,el-icon-document',
    sub_log: '订阅日志,el-icon-tickets'
  };
  nameArr = [
    '帐号列表',
    '部门列表',
    '分组列表',
    '定义列表',
    '规则列表',
    'SIM卡列表',
    '短信列表',
    '订阅列表',
    '用户日志',
    '订阅日志'
  ];
  // menuList = [
  //   {
  //     type: 'el-menu-item',
  //     icon: 'el-icon-s-home',
  //     name: '首页',
  //     index: '/home'
  //   },
  //   {
  //     type: 'el-menu-item',
  //     icon: 'el-icon-s-cooperation',
  //     name: '订单列表',
  //     index: '/collection-order'
  //   },
  //   // {
  //   //   type: 'el-menu-item',
  //   //   icon: 'el-icon-tickets',
  //   //   name: '收款记录',
  //   //   index: '/collection-record'
  //   // },
  //   {
  //     type: 'el-menu-item',
  //     icon: 'el-icon-c-scale-to-original',
  //     name: '短信订单列表',
  //     index: '/sms-order-list'
  //   },
  //   {
  //     type: 'el-menu-item',
  //     icon: 'el-icon-s-claim',
  //     name: '流水列表',
  //     index: '/running-water-details'
  //   }
  //   // {
  //   //   type: 'el-menu-item',
  //   //   icon: 'el-icon-setting',
  //   //   name: '操作记录',
  //   //   index: '/operation-records'
  //   // },
  //   // {
  //   //   type: 'el-menu-item',
  //   //   icon: 'el-icon-user',
  //   //   name: '用户列表',
  //   //   index: '/users'
  //   // }
  // ];
  /**
   * 获取菜单列表
   */
  get_menuList() {
    //@ts-ignore
    this.menuRole = JSON.parse(sessionStorage.getItem('MENU'));
    this.menuRole.forEach(item => {
      //@ts-ignore
      this.menuList = this.nameArr.includes(item['name'])
        ? item['name'] === '用户日志'
          ? [...this.menuList, 'user_log']
          : item['name'] === '订阅日志'
            ? [...this.menuList, 'sub_log']
            : [
                ...this.menuList,
                item['path'].split('/')[item['path'].split('/').length - 2]
              ]
        : [...this.menuList];
    });
    this.menuList.forEach(item => {
      // console.log(item);
      //@ts-ignore
      this.menuContent = [
        ...this.menuContent,
        {
          type: 'el-menu-item',
          //@ts-ignore
          name: this.menuObj[item].split(',')[0],
          //@ts-ignore
          icon: this.menuObj[item].split(',')[1],
          index: `/v1/${item}`
        }
      ];
    });
    // console.log(this.menuContent);
  }
  saveMenu(item: any) {
    this.$emit('saveMenu', [{ name: item.name, index: item.index }]);
  }
  saveMenuSubs(item: any, itemSubs: any) {
    this.$emit('saveMenu', [
      { name: item.name, index: item.index },
      { name: itemSubs.name, index: itemSubs.index }
    ]);
  }
  activeMenu() {
    return this.$route.matched[this.$route.matched.length - 1].path;
  }
}
